import { useEffect, useState } from 'react';
import { getFeatureWithRPC } from '../../common/api/featuresApi';
import { TrialActivationSuccessModal } from './TrialActivationSuccessModal';
import { jsx as _jsx } from "react/jsx-runtime";
const TrialActivationSuccessContainer = ({
  onSuccess,
  upgradeData,
  showTrialLoadingState,
  hasInbound25Gate
}) => {
  const [featureData, setFeatureData] = useState({
    feature: undefined,
    fetched: false
  });
  useEffect(() => {
    if (upgradeData.feature) {
      getFeatureWithRPC({
        shortName: upgradeData.feature
      }).then(feature => {
        setFeatureData({
          feature,
          fetched: true
        });
      }).catch(error => {
        setFeatureData({
          feature: undefined,
          fetched: true
        });
        console.error(error);
      });
    } else {
      setFeatureData({
        feature: undefined,
        fetched: true
      });
    }
  }, [upgradeData]);
  if (hasInbound25Gate === undefined) {
    return null;
  }
  return /*#__PURE__*/_jsx(TrialActivationSuccessModal, {
    showTrialLoadingState: showTrialLoadingState && !featureData.fetched,
    onSuccess: onSuccess,
    upgradeData: upgradeData,
    featureData: featureData.feature,
    hasInbound25Gate: hasInbound25Gate
  });
};
export default TrialActivationSuccessContainer;